import { useState } from "react";

export const TabComponent = ({
  tabNames,
  selectedTab,
  handleTabSwitch,
  buttonClass = "",
  parentClass = "flex-1",
}) => {
  const index = tabNames.findIndex((tab) => tab === selectedTab);
  const [selectedIndex, setSelectedIndex] = useState(index);

  return (
    <div className={`${parentClass} flex 2md:justify-center p-1 rounded-full bg-grey-50`}>
      {tabNames.map((name, index) => (
        <div className="flex items-center w-full min-w-fit" key={index}>
          {index > 0 && index !== selectedIndex && index !== selectedIndex + 1 && (
            <div className="w-[0.5px] h-4 mx-1 bg-grey-border"></div>
          )}
          <button
            key={name}
            className={`${buttonClass} !py-1 !px-3 w-full text-xs rounded-full text-center ${
              selectedTab === name
                ? "font-bold bg-white text-primary shadow-[0px_10px_15px_-3px_rgba(0,0,0,0.1),0px_4px_6px_-2px_rgba(0,0,0,0.05)]"
                : "font-medium bg-grey-50 text-grey-700 hover:bg-grey-200"
            }`}
            onClick={() => {
              setSelectedIndex(index);
              handleTabSwitch(name);
            }}
          >
            {name}
          </button>
        </div>
      ))}
    </div>
  );
};
